import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface ListStateProps {
  isLoading: boolean;
  hasAnyItems: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

export default function ListState({ isLoading, hasAnyItems, emptyMessage, children }: ListStateProps) {
  if (isLoading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (!hasAnyItems) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          minHeight: 0,
          p: 3,
        }}
      >
        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', maxWidth: '600px' }}>
          {emptyMessage || 'No items found.'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
      {children ?? (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            {emptyMessage || 'No items found.'}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
